/**
 * Where the Access pages lead back to (6 Oct, product owner).
 *
 * Admins and IT (`useMe().access_audit`) have the Access area: the cases
 * list, the archive and Completed. Everyone else follows their cases in My
 * Tickets, so their breadcrumb and "back to my requests" go there instead.
 * The list at `/access` still opens for them, showing only their own cases.
 */

import { useT } from "@/i18n";
import { useMe } from "@/lib/api";

export interface AccessHome {
  to: string;
  /** The breadcrumb's label. */
  label: string;
  /** The wizard's top-right link. */
  linkLabel: string;
}

export function useAccessHome(): AccessHome {
  const { t } = useT("tickets");
  const { t: tc } = useT();
  const { data: me } = useMe();
  if (me?.access_audit === true) {
    return { to: "/access", label: t("access.title"), linkLabel: t("access.wizard.toTracker") };
  }
  return { to: "/tickets", label: tc("nav.tickets"), linkLabel: tc("nav.tickets") };
}
